<template>
  <div class="inside_pages_right">
    <div class="regular">
      <div class="tip"></div>
    </div>
    <!-- <div class="safety_score_bg"></div> -->
    <div class="info-top">
      <!-- <div class="chart" id="safety_score_statistics"></div> -->
      <div class="list" v-if="resData.recordInfo.totalNum > 0">
        <div class="li">
          <div class="name">登录得分</div>
          <div class="li-content">
            <score-pie
              :type="1"
              :color="'#B558F6'"
              :echartsData="resData.recordInfo"
            ></score-pie>
            <div class="tip">
              <div class="num" style="color: #B558F6">
                {{ resData.recordInfo.loginIntergral }}
              </div>
              <div class="txt">得分</div>
              <div class="num" style="color: #B558F6">
                {{
                  (
                    (resData.recordInfo.loginIntergral * 100) /
                    resData.recordInfo.totalNum
                  ).toFixed(2)
                }}%
              </div>
              <div class="txt">占比</div>
            </div>
          </div>
        </div>
        <div class="li">
          <div class="name">账号管理</div>
          <div class="li-content">
            <score-pie
              :type="2"
              :color="'#2886FA'"
              :echartsData="resData.recordInfo"
            ></score-pie>
            <div class="tip">
              <div class="num" style="color: #2886FA">
                {{ resData.recordInfo.userinfoIntergral }}
              </div>
              <div class="txt">得分</div>
              <div class="num" style="color: #2886FA">
                {{
                  (
                    (resData.recordInfo.userinfoIntergral * 100) /
                    resData.recordInfo.totalNum
                  ).toFixed(2)
                }}%
              </div>
              <div class="txt">占比</div>
            </div>
          </div>
        </div>
        <div class="li">
          <div class="name">日常巡查</div>
          <div class="li-content">
            <score-pie
              :type="3"
              :color="'#F69B58'"
              :echartsData="resData.recordInfo"
            ></score-pie>
            <div class="tip">
              <div class="num" style="color: #F69B58">
                {{ resData.recordInfo.patrolIntergral }}
              </div>
              <div class="txt">得分</div>
              <div class="num" style="color: #F69B58">
                {{
                  (
                    (resData.recordInfo.patrolIntergral * 100) /
                    resData.recordInfo.totalNum
                  ).toFixed(2)
                }}%
              </div>
              <div class="txt">占比</div>
            </div>
          </div>
        </div>
        <div class="li">
          <div class="name">值班上报</div>
          <div class="li-content">
            <score-pie
              :type="4"
              :color="'#24C8F7'"
              :echartsData="resData.recordInfo"
            ></score-pie>
            <div class="tip">
              <div class="num" style="color: #24C8F7">
                {{ resData.recordInfo.dutyReportIntergral }}
              </div>
              <div class="txt">得分</div>
              <div class="num" style="color: #24C8F7">
                {{
                  (
                    (resData.recordInfo.dutyReportIntergral * 100) /
                    resData.recordInfo.totalNum
                  ).toFixed(2)
                }}%
              </div>
              <div class="txt">占比</div>
            </div>
          </div>
        </div>
        <div class="li">
          <div class="name">隐患管理</div>
          <div class="li-content">
            <score-pie
              :type="5"
              :color="'#FF4500'"
              :echartsData="resData.recordInfo"
            ></score-pie>
            <div class="tip">
              <div class="num" style="color: #FF4500">
                {{ resData.recordInfo.troubleIntergral }}
              </div>
              <div class="txt">得分</div>
              <div class="num" style="color: #FF4500">
                {{
                  (
                    (resData.recordInfo.troubleIntergral * 100) /
                    resData.recordInfo.totalNum
                  ).toFixed(2)
                }}%
              </div>
              <div class="txt">占比</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="safety_score_content">
      <el-row style="padding: 10px;border-bottom:1px solid #EEEEEE;">
        <el-col :span="18">
          <div
            style="text-align: left;font-size: 16px;color:#303030;font-weight: 500;"
          >
            <span>排名具体数据</span>
            <el-button
              style="margin-left:30px;"
              size="mini"
              type="primary"
              @click="check()"
            >
              评分规则
            </el-button>
          </div>
        </el-col>
        <el-col :span="6">
          <el-date-picker
            size="mini"
            v-model="dates"
            type="daterange"
            align="right"
            unlink-panels
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="pickerOptions"
            @change="datePickerChange"
            value-format="timestamp"
            style="z-index:10;width:100%"
          >
          </el-date-picker>
        </el-col>
      </el-row>
      <!-- <div class="table-wrapper_bg"></div> -->
      <div class="table-wrapper">
        <el-table
          :data="resData.pageInfo.list"
          height="500px"
          class="content-table"
          :border="true"
        >
          <el-table-column label="排名" align="center">
            <template v-slot="scope">
              <img
                v-if="
                  requestData.pageSize * (requestData.pageNum - 1) +
                    scope.$index ==
                    0
                "
                height="30px"
                src="@/assets/img/safetyScore/1.png"
                alt=""
              />
              <img
                v-else-if="
                  requestData.pageSize * (requestData.pageNum - 1) +
                    scope.$index ==
                    1
                "
                height="30px"
                src="@/assets/img/safetyScore/2.png"
                alt=""
              />
              <img
                v-else-if="
                  requestData.pageSize * (requestData.pageNum - 1) +
                    scope.$index ==
                    2
                "
                height="30px"
                src="@/assets/img/safetyScore/3.png"
                alt=""
              />
              <span v-else>{{
                requestData.pageSize * (requestData.pageNum - 1) +
                  scope.$index +
                  1
              }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="userName" label="老师名称" align="center">
            <template v-slot="scope">
              <span
                v-if="
                  requestData.pageSize * (requestData.pageNum - 1) +
                    scope.$index ==
                    0
                "
                style="color:#E442E0"
                >{{ scope.row.userName }}</span
              >
              <span
                v-else-if="
                  requestData.pageSize * (requestData.pageNum - 1) +
                    scope.$index ==
                    1
                "
                style="color:#E442E0"
                >{{ scope.row.userName }}</span
              >
              <span
                v-else-if="
                  requestData.pageSize * (requestData.pageNum - 1) +
                    scope.$index ==
                    2
                "
                style="color:#E442E0"
                >{{ scope.row.userName }}</span
              >
              <span v-else>{{ scope.row.userName }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="loginIntergral"
            label="登录得分"
            align="center"
          >
            <template v-slot="scope">
              <span
                v-if="
                  requestData.pageSize * (requestData.pageNum - 1) +
                    scope.$index ==
                    0
                "
                style="color:#E442E0"
                >{{ scope.row.loginIntergral }}</span
              >
              <span
                v-else-if="
                  requestData.pageSize * (requestData.pageNum - 1) +
                    scope.$index ==
                    1
                "
                style="color:#E442E0"
                >{{ scope.row.loginIntergral }}</span
              >
              <span
                v-else-if="
                  requestData.pageSize * (requestData.pageNum - 1) +
                    scope.$index ==
                    2
                "
                style="color:#E442E0"
                >{{ scope.row.loginIntergral }}</span
              >
              <span v-else>{{ scope.row.loginIntergral }}</span>
            </template>
          </el-table-column>
          <el-table-column label="账号管理" align="center">
            <el-table-column
              prop="userinfoIntergral"
              label="账号信息完善"
              align="center"
            >
              <template v-slot="scope">
                <span
                  v-if="
                    requestData.pageSize * (requestData.pageNum - 1) +
                      scope.$index ==
                      0
                  "
                  style="color:#E442E0"
                  >{{ scope.row.userinfoIntergral }}</span
                >
                <span
                  v-else-if="
                    requestData.pageSize * (requestData.pageNum - 1) +
                      scope.$index ==
                      1
                  "
                  style="color:#E442E0"
                  >{{ scope.row.userinfoIntergral }}</span
                >
                <span
                  v-else-if="
                    requestData.pageSize * (requestData.pageNum - 1) +
                      scope.$index ==
                      2
                  "
                  style="color:#E442E0"
                  >{{ scope.row.userinfoIntergral }}</span
                >
                <span v-else>{{ scope.row.userinfoIntergral }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="userinfoIntergral"
              label="修改密码"
              align="center"
            >
              <template v-slot="scope">
                <span
                  v-if="
                    requestData.pageSize * (requestData.pageNum - 1) +
                      scope.$index ==
                      0
                  "
                  style="color:#E442E0"
                  >{{ scope.row.changePwdIntergral }}</span
                >
                <span
                  v-else-if="
                    requestData.pageSize * (requestData.pageNum - 1) +
                      scope.$index ==
                      1
                  "
                  style="color:#E442E0"
                  >{{ scope.row.changePwdIntergral }}</span
                >
                <span
                  v-else-if="
                    requestData.pageSize * (requestData.pageNum - 1) +
                      scope.$index ==
                      2
                  "
                  style="color:#E442E0"
                  >{{ scope.row.changePwdIntergral }}</span
                >
                <span v-else>{{ scope.row.changePwdIntergral }}</span>
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column label="隐患管理" align="center">
            <el-table-column
              prop="reportTroubleIntergral"
              label="隐患上报"
              align="center"
            >
              <template v-slot="scope">
                <span
                  v-if="
                    requestData.pageSize * (requestData.pageNum - 1) +
                      scope.$index ==
                      0
                  "
                  style="color:#E442E0"
                  >{{ scope.row.reportTroubleIntergral }}</span
                >
                <span
                  v-else-if="
                    requestData.pageSize * (requestData.pageNum - 1) +
                      scope.$index ==
                      1
                  "
                  style="color:#E442E0"
                  >{{ scope.row.reportTroubleIntergral }}</span
                >
                <span
                  v-else-if="
                    requestData.pageSize * (requestData.pageNum - 1) +
                      scope.$index ==
                      2
                  "
                  style="color:#E442E0"
                  >{{ scope.row.reportTroubleIntergral }}</span
                >
                <span v-else>{{ scope.row.reportTroubleIntergral }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="revokeTroubleIntergral"
              label="隐患撤销"
              align="center"
            >
              <template v-slot="scope">
                <span
                  v-if="
                    requestData.pageSize * (requestData.pageNum - 1) +
                      scope.$index ==
                      0
                  "
                  style="color:#E442E0"
                  >{{ scope.row.revokeTroubleIntergral }}</span
                >
                <span
                  v-else-if="
                    requestData.pageSize * (requestData.pageNum - 1) +
                      scope.$index ==
                      1
                  "
                  style="color:#E442E0"
                  >{{ scope.row.revokeTroubleIntergral }}</span
                >
                <span
                  v-else-if="
                    requestData.pageSize * (requestData.pageNum - 1) +
                      scope.$index ==
                      2
                  "
                  style="color:#E442E0"
                  >{{ scope.row.revokeTroubleIntergral }}</span
                >
                <span v-else>{{ scope.row.revokeTroubleIntergral }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="assignTroubleIntergral"
              label="隐患指派"
              align="center"
            >
              <template v-slot="scope">
                <span
                  v-if="
                    requestData.pageSize * (requestData.pageNum - 1) +
                      scope.$index ==
                      0
                  "
                  style="color:#E442E0"
                  >{{ scope.row.assignTroubleIntergral }}</span
                >
                <span
                  v-else-if="
                    requestData.pageSize * (requestData.pageNum - 1) +
                      scope.$index ==
                      1
                  "
                  style="color:#E442E0"
                  >{{ scope.row.assignTroubleIntergral }}</span
                >
                <span
                  v-else-if="
                    requestData.pageSize * (requestData.pageNum - 1) +
                      scope.$index ==
                      2
                  "
                  style="color:#E442E0"
                  >{{ scope.row.assignTroubleIntergral }}</span
                >
                <span v-else>{{ scope.row.assignTroubleIntergral }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="redeployTroubleIntergral"
              label="隐患转派"
              align="center"
            >
              <template v-slot="scope">
                <span
                  v-if="
                    requestData.pageSize * (requestData.pageNum - 1) +
                      scope.$index ==
                      0
                  "
                  style="color:#E442E0"
                  >{{ scope.row.redeployTroubleIntergral }}</span
                >
                <span
                  v-else-if="
                    requestData.pageSize * (requestData.pageNum - 1) +
                      scope.$index ==
                      1
                  "
                  style="color:#E442E0"
                  >{{ scope.row.redeployTroubleIntergral }}</span
                >
                <span
                  v-else-if="
                    requestData.pageSize * (requestData.pageNum - 1) +
                      scope.$index ==
                      2
                  "
                  style="color:#E442E0"
                  >{{ scope.row.redeployTroubleIntergral }}</span
                >
                <span v-else>{{ scope.row.redeployTroubleIntergral }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="handleTroubleIntergral"
              label="隐患整改"
              align="center"
            >
              <template v-slot="scope">
                <span
                  v-if="
                    requestData.pageSize * (requestData.pageNum - 1) +
                      scope.$index ==
                      0
                  "
                  style="color:#E442E0"
                  >{{ scope.row.handleTroubleIntergral }}</span
                >
                <span
                  v-else-if="
                    requestData.pageSize * (requestData.pageNum - 1) +
                      scope.$index ==
                      1
                  "
                  style="color:#E442E0"
                  >{{ scope.row.handleTroubleIntergral }}</span
                >
                <span
                  v-else-if="
                    requestData.pageSize * (requestData.pageNum - 1) +
                      scope.$index ==
                      2
                  "
                  style="color:#E442E0"
                  >{{ scope.row.handleTroubleIntergral }}</span
                >
                <span v-else>{{ scope.row.handleTroubleIntergral }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="checkTroubleIntergral"
              label="隐患验收"
              align="center"
            >
              <template v-slot="scope">
                <span
                  v-if="
                    requestData.pageSize * (requestData.pageNum - 1) +
                      scope.$index ==
                      0
                  "
                  style="color:#E442E0"
                  >{{ scope.row.checkTroubleIntergral }}</span
                >
                <span
                  v-else-if="
                    requestData.pageSize * (requestData.pageNum - 1) +
                      scope.$index ==
                      1
                  "
                  style="color:#E442E0"
                  >{{ scope.row.checkTroubleIntergral }}</span
                >
                <span
                  v-else-if="
                    requestData.pageSize * (requestData.pageNum - 1) +
                      scope.$index ==
                      2
                  "
                  style="color:#E442E0"
                  >{{ scope.row.checkTroubleIntergral }}</span
                >
                <span v-else>{{ scope.row.checkTroubleIntergral }}</span>
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column
            prop="patrolIntergral"
            label="日常巡查"
            align="center"
          >
            <template v-slot="scope">
              <span
                v-if="
                  requestData.pageSize * (requestData.pageNum - 1) +
                    scope.$index ==
                    0
                "
                style="color:#E442E0"
                >{{ scope.row.patrolIntergral }}</span
              >
              <span
                v-else-if="
                  requestData.pageSize * (requestData.pageNum - 1) +
                    scope.$index ==
                    1
                "
                style="color:#E442E0"
                >{{ scope.row.patrolIntergral }}</span
              >
              <span
                v-else-if="
                  requestData.pageSize * (requestData.pageNum - 1) +
                    scope.$index ==
                    2
                "
                style="color:#E442E0"
                >{{ scope.row.patrolIntergral }}</span
              >
              <span v-else>{{ scope.row.patrolIntergral }}</span>
            </template>
          </el-table-column>

          <el-table-column
            prop="dutyReportIntergral"
            label="值班上报"
            align="center"
          >
            <template v-slot="scope">
              <span
                v-if="
                  requestData.pageSize * (requestData.pageNum - 1) +
                    scope.$index ==
                    0
                "
                style="color:#E442E0"
                >{{ scope.row.dutyReportIntergral }}</span
              >
              <span
                v-else-if="
                  requestData.pageSize * (requestData.pageNum - 1) +
                    scope.$index ==
                    1
                "
                style="color:#E442E0"
                >{{ scope.row.dutyReportIntergral }}</span
              >
              <span
                v-else-if="
                  requestData.pageSize * (requestData.pageNum - 1) +
                    scope.$index ==
                    2
                "
                style="color:#E442E0"
                >{{ scope.row.dutyReportIntergral }}</span
              >
              <span v-else>{{ scope.row.dutyReportIntergral }}</span>
            </template>
          </el-table-column>

          <el-table-column prop="totalNum" label="得分" align="center">
            <template v-slot="scope">
              <span
                v-if="
                  requestData.pageSize * (requestData.pageNum - 1) +
                    scope.$index ==
                    0
                "
                style="color:#E442E0"
                >{{ scope.row.totalNum }}</span
              >
              <span
                v-else-if="
                  requestData.pageSize * (requestData.pageNum - 1) +
                    scope.$index ==
                    1
                "
                style="color:#E442E0"
                >{{ scope.row.totalNum }}</span
              >
              <span
                v-else-if="
                  requestData.pageSize * (requestData.pageNum - 1) +
                    scope.$index ==
                    2
                "
                style="color:#E442E0"
                >{{ scope.row.totalNum }}</span
              >
              <span v-else>{{ scope.row.totalNum }}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div
        class="safety_score_content_page"
        style="padding:10px"
        v-if="resData.pageInfo.total > 0"
      >
        <div class="block">
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page="requestData.pageNum"
            :page-size="requestData.pageSize"
            layout="total, prev, pager, next, jumper"
            :total="resData.pageInfo.total"
          >
          </el-pagination>
        </div>
      </div>
    </div>
    <score-regular :regularResize="regularResize"></score-regular>
  </div>
</template>

<script>
import echarts from "echarts";
import scoreRegular from "./components/SafetyScoreRegular.vue";
import scorePie from "./components/SafetyScorePie.vue";
export default {
  name: "SafetyScore",
  components: {
    scoreRegular,
    scorePie
  },
  props: {},
  data() {
    return {
      dates: "",
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },

      requestData: {
        schoolId: this.$store.state.schoolId,
        pageNum: 1,
        pageSize: 20,
        startTime: "",
        endTime: ""
      },
      resData: {
        troubleIntergral: 0,
        totalNum: 0,
        loginIntergral: 0,
        userinfoIntergral: 0,
        patrolIntergral: 0,
        recordInfo: {
          troubleIntergral: 0,
          totalNum: 0,
          loginIntergral: 0,
          userinfoIntergral: 0,
          patrolIntergral: 0,
          dutyReportIntergral: 0
        },
        pageInfo: {
          list: [],
          pageNum: 0,
          pageSize: 0,
          pages: 0,
          total: 0
        }
      },
      regularResize: 0
    };
  },
  watch: {},
  computed: {},
  methods: {
    handleCurrentChange(val) {
      this.requestData.pageNum = val;
      // console.log(`当前页: ${val}`);
      this.getStatisticalData();
    },
    check() {
      this.regularResize++;
    },
    // 获取统计数据
    async getStatisticalData() {
      var newParamData = this.requestData;
      let res = await this.$Http.safetyScoreStatistics(newParamData);
      if (res.code == 200) {
        this.resData.troubleIntergral = res.data.recordInfo.troubleIntergral;
        this.resData.totalNum = res.data.recordInfo.totalNum;
        this.resData.loginIntergral = res.data.recordInfo.loginIntergral;
        this.resData.userinfoIntergral = res.data.recordInfo.userinfoIntergral;
        this.resData.dutyReportIntergral =
          res.data.recordInfo.dutyReportIntergral;
        this.resData.patrolIntergral = res.data.recordInfo.patrolIntergral;
        this.resData.recordInfo = res.data.recordInfo;
        this.resData.pageInfo.list = res.data.pageInfo.list;
        this.resData.pageInfo.pageNum = res.data.pageInfo.pageNum;
        this.resData.pageInfo.pageSize = res.data.pageInfo.pageSize;
        this.resData.pageInfo.pages = res.data.pageInfo.pages;
        this.resData.pageInfo.total = res.data.pageInfo.total;
        // console.log(res.data);
        // this.setPieChart1();
      } else if (res.code == 101) {
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },
    setPieChart1: function() {
      var totalScore = 0;
      var pieChart1 = echarts.init(
        document.getElementById("safety_score_statistics")
      );
      var pieChart1Option = {
        xAxis: {
          type: "category",
          data: ["登录得分", "隐患管理", "日常巡查", "账号管理", "值班上报"]
        },
        yAxis: {
          type: "value"
        },
        grid: {
          left: "0%",
          right: "0%",
          bottom: "5%",
          top: "10%",
          containLabel: true
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow" // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        series: [
          {
            type: "bar",
            name: "得分",
            radius: "55%",
            center: ["50%", "60%"],
            barMaxWidth: 40,

            label: {
              show: true,
              position: "top",
              formatter: function(params) {
                if (totalScore <= 0) {
                  totalScore = parseFloat(totalScore);
                  pieChart1Option.series[0].data.forEach((item) => {
                    // console.log(item.value, 222);
                    totalScore += parseFloat(item.value);
                  });
                }
                var str1 =
                  params.data.value <= 0
                    ? "0%"
                    : Math.round((params.data.value / totalScore) * 10000) /
                        100.0 +
                      "%";
                return "得分占比：" + str1;
              }
            },
            data: [
              {
                name: "登录得分",
                value: this.resData.loginIntergral,
                itemStyle: {
                  color: "#E06A6A"
                }
              },
              {
                name: "隐患管理",
                value: this.resData.troubleIntergral,
                itemStyle: {
                  color: "#6AE091"
                }
              },
              {
                name: "日常巡查",
                value: this.resData.patrolIntergral,
                itemStyle: {
                  color: "#E442E0"
                }
              },
              {
                name: "账号管理",
                value: this.resData.userinfoIntergral,
                itemStyle: {
                  color: "#D3D2FF"
                }
              },
              {
                name: "值班上报",
                value: this.resData.dutyReportIntergral,
                itemStyle: {
                  color: "#f1960c"
                }
              }
            ]
          }
        ]
      };
      pieChart1.setOption(pieChart1Option);
    },
    datePickerChange(val) {
      if (val) {
        this.requestData.startTime = val[0] / 1000 || "";
        this.requestData.endTime = val[1] / 1000 || "";
      } else {
        this.requestData.startTime = "";
        this.requestData.endTime = "";
      }
      this.getStatisticalData();
    }
  },
  created() {},
  mounted() {
    this.getStatisticalData();
  }
};
</script>
<style scoped lang="scss">
.inside_pages_right {
  width: 100%;
}
.regular {
  position: relative;
  .tip {
    padding: 0 60px;
    cursor: pointer;
    position: absolute;
    left: 10px;
    top: 30px;
  }
}
.info-top {
  // width: 100%;
  height: 220px;
  // display: flex;
  // justify-content: center;
  // align-items: center;
  .chart {
    width: 60%;
    height: 100%;
  }
  .list {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .li {
      height: 220px;
      flex: 1 1 29%;
      background: #ffffff;
      border-radius: 5px;
      padding: 15px;
      margin-right: 15px;
      &:last-child {
        margin-right: 0;
      }
      .name {
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 600;
        color: #333333;
      }
      .li-content {
        height: 170px;
        display: flex;
        justify-content: center;
        align-items: center;
        .tip {
          margin-left: 50px;
          text-align: center;
        }
        .num {
          font-size: 18px;
          font-weight: 600;
        }
        .txt {
          font-size: 12px;
          font-weight: 400;
          color: #999999;
        }
      }
    }
  }
}
.safety_score_content {
  margin-top: 15px;
  background: #ffffff;
}
.safety_score_top_title {
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 500;
  color: #303030;
  line-height: 25px;
}
.safety_score_bg {
  // background: url("~@/assets/img/safetyScore/safety_score_bg.png") center center
  //   no-repeat;
  // background-size: 100% 100%;
  // width: 50%;
  // height: 183px;
  // position: absolute;
  // left: 31%;
  // right: 0;
  // top: 170px;
  // bottom: 0;
}
.table-wrapper {
  padding: 10px;
}
.content-table {
  // width: 50%;
  // margin-left: 25%;
  font-size: 20;
  font-weight: 500;
}
.table-wrapper /deep/ .el-table .el-table__body-wrapper {
  scrollbar-width: none;
}
.table-wrapper /deep/ .el-table--fit {
  // padding: 10px;
}
.table-wrapper /deep/ .el-table,
.el-table__expanded-cell {
  background-color: transparent;
}

.table-wrapper /deep/ .el-table tr {
  background-color: transparent !important;
}
.table-wrapper /deep/ .el-table th {
  background-color: transparent !important;
  color: #303030;
}
.table-wrapper /deep/ .el-table--enable-row-transition .el-table__body td,
.el-table .cell {
  background-color: transparent;
}
.table-wrapper_bg {
  // background: url("~@/assets/img/safetyScore/table-bg.png") center center
  //   no-repeat;
  // background-size: 100% 100%;
  width: 50%;
  left: 31%;
  top: 353px;
  position: absolute;
  height: 480px;
}
</style>
